import { render } from "./Placeholder.vue?vue&type=template&id=0081ef29&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"

import "./Placeholder.vue?vue&type=style&index=0&id=0081ef29&scoped=true&lang=scss"
import "./Placeholder.vue?vue&type=style&index=1&id=0081ef29&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0081ef29"]])

export default __exports__